module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-table', {
    ref: "towerSupplierSites",
    attrs: {
      "title": (_vm.name ? _vm.name : 'Tower Supplier') + (_vm.status ? ': ' + _vm.status : ''),
      "title-heading": "h5",
      "url": _vm.supplierId ? _vm.urlSupplier : _vm.urlGroup,
      "fields": _vm.fields,
      "table-ref": "towerSupplierSitesDataTable"
    },
    scopedSlots: _vm._u([{
      key: "show",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "fa fa-angle-double-down"
          },
          on: {
            "click": function($event) {
              return _vm.showSite(scope.rowData.site_id)
            }
          }
        }, [_vm._v(" Show")])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-743ac307"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/PopupSitesReport.vue
// module id = 1555
// module chunks = 0